import { computed, Injectable, Signal, signal, Type, WritableSignal } from '@angular/core';
import { SheetState } from '@models/types/components/BottomSheet.type';
import { Observable, Subject } from 'rxjs';

interface BottomSheetCallback {
  close: Observable<void | undefined>;
}

@Injectable({providedIn: 'root'})
export class BottomSheetService {

  // STATE
  private readonly sheetState: WritableSignal<SheetState>         = signal('closed');
  public  readonly state:      Signal<SheetState>                 = computed((): SheetState => this.sheetState());


  // MOUNTED COMPONENT STATE
  private readonly _component: WritableSignal<Type<unknown>|null> = signal(null);
  public  readonly component:  Signal<Type<unknown>|null>         = computed((): Type<unknown>|null => this._component());


  // CLOSE OBSERVABLE
  private closeSubject:        Subject<void|undefined> | null     = null;


  // ANIMATION DURATION
  public readonly duration:    number                             = 400;


  // METHODS
  public open(component: Type<unknown>, fullScreen: boolean = false): BottomSheetCallback {

    if(this.closeSubject){
      this.closeSubject.next();
      this.closeSubject.complete();
    }

    this.closeSubject = new Subject<void|undefined>();

    this._component.set(component);
    this.sheetState.set(fullScreen ? 'full' : 'open');

    return { close: this.closeSubject.asObservable() };
  }

  public close(): void {

    if(this.closeSubject) {
      this.closeSubject.next();
      this.closeSubject.complete();
      this.closeSubject = null;
    }

    this.sheetState.set('closed');
    setTimeout((): void => this._component.set(null), this.duration);

  }

  public updateFromComponent(state: SheetState): void {

    if(state === 'closed') this.close();
    else this.sheetState.set(state);
    
  }

}
